// How plot pixels are written on chain (millionbitserver reads them back to
// paint the billboard — this format must never change without the server).
//
// One segment per 16x16 cell, row-major:
//   v1|<cellX>,<cellY>|<256 colours as rrggbb, comma-separated>|<bid>|<encodeURIComponent(url)>
// cellX/cellY are billboard cell coordinates (pixel offset / 16 + column/row).
// Segments are joined with "\n" and zlib-deflated by pako as a binary string,
// which is what mint / tokenMint / repaintPixels take as pixelStr.
//
// Pure functions only (no window, lodash or pako globals), so they can be
// unit tested: see e2e/tests/pixels.spec.js.

export const DATA_ENCODING_VERSION = 1;
export const CELL = 16;

export function hexFromRgb(r, g, b) {
  return ('0' + r.toString(16)).slice(-2) + ('0' + g.toString(16)).slice(-2) + ('0' + b.toString(16)).slice(-2);
}

// RGBA bytes of a width x height image -> rows[row][col] = the cell's 256
// pixels ({ r, g, b, a, hex }) in reading order.
export function cellsFromImageData(imageData, width, height) {
  const rows = [];
  const cellRows = height / CELL;
  const cellCols = width / CELL;
  for (let row = 0; row < cellRows; row++) {
    const cols = [];
    for (let col = 0; col < cellCols; col++) cols.push([]);
    rows.push(cols);
  }
  for (let y = 0; y < height; y++) {
    for (let x = 0; x < width; x++) {
      const i = (y * width + x) * 4;
      const r = imageData[i], g = imageData[i + 1], b = imageData[i + 2], a = imageData[i + 3];
      rows[Math.floor(y / CELL)][Math.floor(x / CELL)].push({ r, g, b, a, hex: hexFromRgb(r, g, b) });
    }
  }
  return rows;
}

export function segmentString(cellPixels, url, bid, row, col, offsetX, offsetY) {
  const colors = cellPixels.map((p) => p.hex);
  const xOffset = (offsetX / CELL) + col;
  const yOffset = (offsetY / CELL) + row;
  return 'v' + DATA_ENCODING_VERSION + '|' + xOffset + ',' + yOffset + '|' + colors.join(',') + '|' + bid + '|' + encodeURIComponent(url);
}

// All segments of a plot at (offsetX, offsetY). bidFor(row, col) gives each
// segment's bid (mint: running pixel count; repaint: 0).
export function plotSegments(imageData, width, height, offsetX, offsetY, url, bidFor) {
  const cells = cellsFromImageData(imageData, width, height);
  const segments = [];
  for (let row = 0; row < cells.length; row++) {
    for (let col = 0; col < cells[row].length; col++) {
      segments.push(segmentString(cells[row][col], url, bidFor(row, col), row, col, offsetX, offsetY));
    }
  }
  return segments;
}

// The pixelStr argument for the contract. deflate is pako.deflate.
export function encodeSegments(segments, deflate) {
  return deflate(segments.join('\n'), { to: 'string' });
}
